import { QueryClientProvider } from "@tanstack/react-query";
import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { BrowserRouter } from "react-router";

import { App } from "@/App";
import { watchForUpdates } from "@/lib/app-update";
import { registerServiceWorker } from "@/lib/pwa";
import { createQueryClient } from "@/lib/query-client";

import "./index.css";

// Before React, so a slow first render does not delay the worker taking control — and
// deliberately outside it, because it is not part of any component's lifecycle.
registerServiceWorker();
watchForUpdates();

const container = document.getElementById("root");
if (!container) {
  throw new Error("Root element is missing from index.html.");
}

createRoot(container).render(
  <StrictMode>
    <QueryClientProvider client={createQueryClient()}>
      <BrowserRouter>
        <App />
      </BrowserRouter>
    </QueryClientProvider>
  </StrictMode>,
);
